module.exports = __webpack_public_path__ + "img/logo-portal-bco.1425adf0.svg";